const timeoutMessageElement = document.getElementById('timeout-message');
const timeoutMessage = window.localStorage.getItem('timeoutMessage');

if (timeoutMessageElement && timeoutMessage) {
    timeoutMessageElement.innerText = timeoutMessage;
    window.localStorage.removeItem('timeoutMessage');
}
